(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lorenzi-variant-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorenzi-variant-row')) {
    customElements.define(
      'lorenzi-variant-row',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-row-track]');
          this.prev = this.querySelector('[data-row-prev]');
          this.next = this.querySelector('[data-row-next]');
          if (!this.track || !this.prev || !this.next) return;
          const step = (dir) => {
            const card = this.track.firstElementChild;
            const width = card ? card.getBoundingClientRect().width : this.track.clientWidth;
            this.track.scrollBy({ left: dir * width, behavior: 'smooth' });
          };
          this.prev.addEventListener('click', () => step(-1));
          this.next.addEventListener('click', () => step(1));
          this.sync = () => {
            this.prev.hidden = this.track.scrollLeft <= 1;
            this.next.hidden = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
          };
          this.track.addEventListener('scroll', this.sync, { passive: true });
          this.observer = new ResizeObserver(this.sync);
          this.observer.observe(this.track);
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
